<template>
  <div class="KPI">
    <!-- <el-select v-model="LastDay" placeholder="请选择结算时间" @change="selextTime">
      <el-option v-for="(item,index) in KpiDayList" :key="index" :label="item" :value="item"></el-option>
    </el-select> -->
    <div>日期：{{KpiDayList[0]}}</div>
    <el-row :gutter="20">
      <el-col :xs="12" :sm="12" :lg="6">
        <div class="grid-content bg-purple flex titleText">
          <span>
            总工时
            <span style="color: #40c9c6;">{{KpiTime.total_hours}}</span> 小时
          </span>
        </div>
      </el-col>
      <!-- <el-col :xs="12" :sm="12" :lg="6">
        <div class="grid-content bg-purple flex titleText">
          <span>
            已结算总工时
            <span style="color:#36a3f7;">{{KpiTime.total_payed_hours}}</span> 小时
          </span>
        </div>
      </el-col> -->
      <!-- <el-col :xs="12" :sm="12" :lg="6">
        <div class="grid-content bg-purple flex titleText">
          <span>
            未结算总工时
            <span style="color:#f4516c;">{{KpiTime.total_not_payed_hours}}</span> 小时
          </span>
        </div>
      </el-col> -->
      <el-col :xs="12" :sm="12" :lg="6">
        <div class="grid-content bg-purple flex titleText">
          <span>
            调休无法抵扣工时
            <span style="color:#13ce66;">{{KpiTime.daysoff_hours}}</span> 小时
          </span>
        </div>
      </el-col>
    </el-row>
    <!-- <el-divider content-position="left">项目KPI工时</el-divider>
    <el-row :gutter="32">
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-wrapper">
          <div class="flexcolum projectZj">
            <span
              class="projectText titleText"
              style="font-size:24px;color:#409EFF;margin-top:20px;"
            >
              总项目工时
              <span style="color: #40c9c6;">{{KpiTime.project_total_hours}}</span> 小时
            </span>
            <div class="xmyandwtime">
              <span class="projectText">
                已结算工时:
                <span style="color:#36a3f7;">{{KpiTime.project_total_payed_hours}}</span> 小时
              </span>
              <span class="projectText">
                未结算工时:
                <span style="color:#f4516c;">{{KpiTime.project_total_not_payed_hours}}</span> 小时
              </span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-wrapper">
          <pie-chart :pieData.sync="pieData"></pie-chart>
        </div>
      </el-col>
    </el-row>

    <el-divider content-position="left">公司KPI工时</el-divider>
    <el-row :gutter="32">
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-wrapper">
          <div class="flexcolum projectZj">
            <span
              class="projectText titleText"
              style="font-size:24px;color:#409EFF;margin-top:20px;"
            >
              公司总工时
              <span style="color: #40c9c6;">{{KpiTime.company_total_hours}}</span> 小时
            </span>
            <div class="xmyandwtime">
              <span class="projectText">
                已结算工时:
                <span style="color:#36a3f7;">{{KpiTime.company_total_payed_hours}}</span> 小时
              </span>
              <span class="projectText">
                未结算工时:
                <span style="color:#f4516c;">{{KpiTime.company_total_not_payed_hours}}</span> 小时
              </span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-wrapper">
          <pie-chart
            :pieData.sync="companyPieData"
            :pietitle="companypietitle"
            :piecolor="companypiecolor"
            :tooltipname = "companypietitle"
          ></pie-chart>
        </div>
      </el-col>
    </el-row> -->

    <el-divider content-position="left">加班工时</el-divider>
    <el-row :gutter="32">
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-wrapper">
          <div class="flexcolum projectZj">
            <span
              class="projectText titleText"
              style="font-size:24px;color:#409EFF;margin-top:20px;"
            >
              总加班工时
              <span style="color: #40c9c6;">{{KpiTime.overtime_total_hours}}</span> 小时
            </span>
            <div class="xmyandwtime">
              <span class="projectText">
                已使用工时:
                <span style="color:#36a3f7;">{{KpiTime.overtime_total_used_hours}}</span> 小时
              </span>
              <span class="projectText">
                未使用工时:
                <span style="color:#f4516c;">{{KpiTime.overtime_total_not_used_hours}}</span> 小时
              </span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-wrapper">
          <pie-chart
            :pieData.sync="overtimePieData"
            :legendData="overtimelegendData"
            :pietitle="overtimepietitle"
            :piecolor="overtimepiecolor"
            :tooltipname = "overtimepietitle"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import PieChart from "./PieChart";
import axios from "axios";
import { getuserInfo } from "@/lib/until";
import { showLoading, hideLoading } from "@/lib/loading";
export default {
  name: "",
  components: {
    PieChart
  },
  data() {
    return {
      KpiDayList: [],
      LastDay: "",
      KpiTime: {},
      pieData: [],
      companyPieData: [],
      overtimePieData: [],
      overtimelegendData: ["已使用", "未使用"],
      overtimepietitle: "加班工时",
      companypietitle: "公司总工时",
      companypiecolor: ["#ED868C", "#63C2FF"],
      overtimepiecolor: ["#99CCCC", "#FFCB8C"],

    };
  },
  mounted() {
    this.getKPIday();
  },

  methods: {
    getKPIday() {
      axios
        .get(IPConfig.IP + "/kpi-management/ppdata/paydate.php")
        .then(res => {
          //console.log(res.data);
          if (0 == res.data.errcode) {
            if (
              res.data.payment_create_dates &&
              res.data.payment_create_dates.length > 0
            ) {
              this.KpiDayList = res.data.payment_create_dates;
              this.LastDay = this.KpiDayList[0];
              //console.log(this.KpiDayList[this.KpiDayList.length-1]);
              this.getKpiTime(this.LastDay);
            }
          }
        })
        .catch(error => {
          //console.log(error);
        });
    },
    getKpiTime(date) {
      showLoading();
      var getInfo = getuserInfo();
      axios
        .get(IPConfig.IP + "/kpi-management/ppdata/summary.php", {
          params: {
            employee_id: getInfo.employee_id,
            payment_create_date: date
          }
        })
        .then(res => {
          //console.log(res.data);
          if (0 == res.data.errcode) {
            this.KpiTime = res.data;
            this.pieData = [
              { value: this.KpiTime.project_total_payed_hours, name: "已结算" },
              {
                value: this.KpiTime.project_total_not_payed_hours,
                name: "未结算"
              }
            ];
            this.companyPieData = [
              { value: this.KpiTime.company_total_payed_hours, name: "已结算" },
              {
                value: this.KpiTime.company_total_not_payed_hours,
                name: "未结算"
              }
            ];
            this.overtimePieData = [
              { value: this.KpiTime.overtime_total_used_hours, name: "已使用" },
              {
                value: this.KpiTime.overtime_total_not_used_hours,
                name: "未使用"
              }
            ];
          }
        })
        .catch(error => {
          //console.log(error);
          hideLoading();
        });
        hideLoading();
    },
    selextTime(){
      // console.log(this.LastDay);
      this.getKpiTime(this.LastDay);
    }
  }
};
</script>

<style scoped>
.KPI {
  padding: 20px 40px;
  background-color: #f0f2f5;
  position: relative;
  height: 100%;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  margin-top: 20px;
  margin-bottom: 30px;
  border-radius: 4px;
  min-height: 84px;
  /* cursor: pointer; */
  font-size: 22px;
  position: relative;
  overflow: hidden;
  color: #666;

  -webkit-box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-divider__text {
  /* background-color:#13ce66; */
  background-color: #d1e9ff;
  padding: 6px 20px;
  color: #666;
  font-size: 18px;
}
.el-divider--horizontal {
  margin: 30px 0;
}
.chart-wrapper {
  background: #fff;
  padding: 16px 16px 0;
  margin-bottom: 32px;
  min-height: 206px;
}
.flexcolum {
  flex-direction: column;
  display: flex;
  justify-content: center;
}
.projectZj {
  text-align: left;
}
.projectText {
  padding: 10px;
  font-size: 20px;
}
.xmyandwtime {
  padding: 20px 0;
}
.titleText {
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/views/KpiTime/index.vue